import { naiveTrackCartContents } from "~/app/analytics/ga/abandonment";
import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import { occCartUserPath } from "~/app/api/occ/occUserPath";
import { getCurrentBrowserTimezone } from "~/common/utils/dateUtils";
import type { AddToCartApiItem, AddToCartResponseItem, BulkAddToCartResponseDTO } from "./AddToCart";

/**
 * Atomically replaces one explicitly identified cart with the submitted entries.
 *
 * This intentionally bypasses the legacy delete/add scheduler: the backend keeps the old cart
 * authoritative unless the complete replacement succeeds.
 */
export async function replaceCartWithEntries(
  activeCartId: string,
  items: AddToCartApiItem[],
  skipTracking = false,
): Promise<AddToCartResponseItem[]> {
  if (!activeCartId) {
    throw new Error("Cannot replace cart without an explicit Active Cart identity");
  }

  const response = await occFetch(
    occBaseSiteUrl(`${occCartUserPath()}/carts/${encodeURIComponent(activeCartId)}/replaceWithEntries`),
    {
      body: JSON.stringify({
        items,
        userTimeZone: getCurrentBrowserTimezone(),
      }),
      headers: {
        "content-type": "application/json",
      },
      method: "POST",
    },
  );

  if (!response.ok) {
    throw new Error(`Failed to replace cart entries: ${response.status}`);
  }

  const data = (await response.json()) as BulkAddToCartResponseDTO;
  if (!skipTracking) {
    naiveTrackCartContents();
  }
  return data.items ?? [];
}
